import { render, staticRenderFns } from "./shopNewItem.vue?vue&type=template&id=1de945d7"
import script from "./shopNewItem.vue?vue&type=script&lang=js"
export * from "./shopNewItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports